import { EgretLoadable } from "egret";



const adminDashboard = EgretLoadable({
  loader: () => import("./AdminDashboard")
});


const adminDashboardRoutes = [
  {
    path: "/agentDashboard", 
    component: adminDashboard
  }
];
 
export default adminDashboardRoutes;
